import { useState, useRef, useEffect } from 'react'
import SearchStatus from './SearchStatus'
import DetailsTable from './DetailsTable'
import DetailsTabsContainer from './DetailsTabsContainer';

const CitizenshipContainer = () => {
  const [selectedStatus, setSelectedStatus] = useState('Choose status');
  const [loadedStatus, setLoadedStatus] = useState<string | null>(null); // Track which status is currently loaded
  const [selectedApplicationData, setSelectedApplicationData] = useState<any>(null);
  const detailsRef = useRef<HTMLDivElement>(null);

  const handleStatusChange = (status: string) => {
    setSelectedStatus(status);
    setSelectedApplicationData(null); // Hide details when status changes
  };

  const handleViewResults = () => {
    if (selectedStatus !== 'Choose status' && selectedStatus) {
      setLoadedStatus(selectedStatus);
    }
  };

  const handleViewDetails = (rowData: any) => {
    setSelectedApplicationData(rowData);
  };

  // Scroll to details section when application data is selected
  useEffect(() => {
    if (selectedApplicationData && detailsRef.current) {
      // Use setTimeout to ensure DOM has updated
      setTimeout(() => {
        detailsRef.current?.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }, 100);
    }
  }, [selectedApplicationData]);

  return (
    <div className='min-h-screen'>
      <SearchStatus 
        selectedStatus={selectedStatus}
        onStatusChange={handleStatusChange}
        onViewResults={handleViewResults}
      />
      
      {loadedStatus && (
        <DetailsTable 
          selectedStatus={loadedStatus} 
          onViewDetails={handleViewDetails}
        />
      )}
      
      {selectedApplicationData && (
        <div ref={detailsRef} className="scroll-mt-8">
          <DetailsTabsContainer 
            applicationData={selectedApplicationData}
          />
        </div>
      )}
    </div>
  )
}

export default CitizenshipContainer
